import { ApiError } from "./api";

export function errorMessage(error: unknown, fallback = "发生未知错误"): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
